import { render, staticRenderFns } from "./CppCodeEditor.vue?vue&type=template&id=4f8c50be&scoped=true&"
import script from "./CppCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./CppCodeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CppCodeEditor.vue?vue&type=style&index=0&id=4f8c50be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c50be",
  null
  
)

export default component.exports